import React, { useState } from 'react';
import { PopupSurvey } from '../components/popups';
import { useLang } from '../../_LangContext';
import LocaleService from '../../services/LocaleService';
import GLOBAL from '../../../_json/_global.json';

const MenuScreenAbout = ({ lang }) =>
{
    const { getText } = useLang();
    const [surveyModalOpen, setSurveyModalOpen] = useState(false);

    const getMessage = (key) =>
    {
        return LocaleService.getMessage(lang, key, '');
    };

    const howtoURL = `/${lang}/how-to`;

    return (
        <>
        <div className="modal-screen about" data-id="3">
            <section className="title">
                <h2 className="app-title">{getText('app-name')}</h2>
            </section>

            <section className="how-to">
                <h3 className="section-title">{getText('howto')}</h3>
                <p dangerouslySetInnerHTML={{ __html: getText('info-howto')}}></p>
                <a className="btn normal w-icon t-b next" href={howtoURL} target="_blank" rel="noreferrer">
                    <div className="btn-label">
                        {getText('goto-howto')}
                    </div>
                </a>
            </section>

            <section className="survey">
                <h3 className="section-title">{getText('survey-title')}</h3>
                <p>{getText('survey-lead')}</p>
                <button 
                    className="btn normal w-icon t-b next" 
                    onClick={() => setSurveyModalOpen(true)}
                >
                    <div className="btn-label">
                        {getText('survey-here')}
                    </div>
                </button>
            </section>

            <section className="browser">
                <h3 className="section-title">{getMessage('recommended')}</h3>
                <dl className="info-item">
                    <dt>{getMessage('pc-h')}</dt>
                    <dd>
                        <p>{getMessage('pc-1')}</p>
                        <p>{getMessage('pc-2')}</p>
                    </dd>
                </dl>
                <dl className="info-item">
                    <dt>{getMessage('sp-h')}</dt>
                    <dd>
                        <p>{getMessage('sp-1')}</p>
                        <p>{getMessage('sp-2')}</p>
                    </dd>
                </dl>
                <p className="note">{getMessage('gps-note')}</p>
            </section>

            <section className="copyright">
                <p className="copyright">{GLOBAL.copyright}</p>
            </section>
        </div>
        <PopupSurvey 
            isOpen={surveyModalOpen}
            onClose={() => setSurveyModalOpen(false)}
            lang={lang}
        />
        </>
    );
};

export default MenuScreenAbout; 